import { PublicCookie } from "../models/public-cookie.model";
import { CookieHelper } from "./cookie.helper";

export class PublicCookieHelper {
    private static readonly cookieName = "Auth.PublicCookies";

    public static get(): PublicCookie {
        return JSON.parse(CookieHelper.getCookie(PublicCookieHelper.cookieName), (key, value) => {
            if (key === "tokenExpiration") {
                return new Date(value);
            }
            return value;
        }) as PublicCookie
    }

    public static create(publicCookie: PublicCookie) {
        CookieHelper.setCookie(PublicCookieHelper.cookieName, encodeURIComponent(JSON.stringify(publicCookie)));
    }

    public static isValid(publicCookie: PublicCookie): boolean {
        return publicCookie && publicCookie.isAuthenticated;
    }

    public static getExpirationMinusSafetyTime(publicCookie: PublicCookie, safetyTimeInSeconds: number): number {
        return publicCookie.tokenExpiration.getTime() - (safetyTimeInSeconds * 1000);
    }

    public static deletePublicCookie() {
        document.cookie = PublicCookieHelper.cookieName+'=; Max-Age=-99999999;'; 
    }
}